import { createOpenStore } from "stores/createOpenStore";

export const useModelShareStore = createOpenStore<{ modelId: string }>();
